module.exports = __webpack_public_path__ + "static/media/logo-seticap-sinbg.7f1890bc.png";